import PropTypes from 'prop-types';
import React from 'react';
import { sanitiseText } from '../../helpers/sanitiseText';

const Title = ({ count, text, title }) => {
  return (
    <>
      <div className="container">
        <div className="title-container">
          <h2>{title}</h2>

          <span className="title-count">- {count} deals</span>
        </div>
        {text ?? (
          <div
            dangerouslySetInnerHTML={{
              __html: sanitiseText(text),
            }}
          />
        )}
      </div>

      <style jsx>{`
        .container {
          padding: 0 15px 10px 15px;
        }
        .title-container {
          display: flex;
          align-items: center;
          justify-content: left;
        }
        .title-count {
          font-size: 14px;
          padding: 0 5px;
          white-space: nowrap;
        }

        @media (max-width: 575.98px) {
          .title-count {
            font-size: 12px;
            white-space: nowrap;
          }
        }
      `}</style>
    </>
  );
};

Title.propTypes = {
  count: PropTypes.number,
  text: PropTypes.string,
  title: PropTypes.string,
};

export default Title;
